// extracted by mini-css-extract-plugin
export var conversationListItem = "_yf-2";
export var fullBleedList = "_yf-3";
export var messageText = "_yf-1";
export var previewText = "_yf-0";